'use client';

import { MdSentimentVeryDissatisfied } from 'react-icons/md';
import errorPpageBackground from '../../../../public/images/error-page-background.jpg';
import Image from 'next/image';
import { useRouter } from 'next/navigation';

export default function NotFound() {
  const router = useRouter();
  return (
    <main className="flex -mt-32 h-full flex-col items-center justify-center bg-[#aabfd6]">
      <div className="relative  h-full min-h-[300px]  ">
        <Image
          className=" z-30"
          src={errorPpageBackground}
          alt={'error ppage background'}
          style={{ objectFit: 'cover' }}
        />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center space-y-4">
          <div className="flex h-full flex-col items-center justify-center gap-2">
            <MdSentimentVeryDissatisfied className="w-10 sm:h-7  md:h-8 text-white " />
            <h2 className="text-white text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl font-bold leading-[64px]">
              404 Not Found
            </h2>
            <p className="text-white text-lg sm:text-xl md:text-2xl font-bold font-roboto leading-[64px]">
              Could not find the requested course.
            </p>
            <button
              onClick={() => router.back()}
              className="mt-4 rounded-md bg-black px-4 py-2 text-sm sm:text-lg md:text-xl lg:text-2xl font-roboto text-white transition-colors hover:bg-gray-500  "
            >
              Go Back
            </button>
          </div>
        </div>
      </div>
    </main>
  );
}
